import React, { ReactElement } from 'react';
import styled from 'styled-components/macro';
import { CSSTransition } from 'react-transition-group';
import { useFaderTimer } from './useFaderTimer';

const transitionDuration = 500; // must match transition speed in css

type Props = {
  children: ReactElement[];
  speed: number;
  itemsToShow: number;
};

export const Fader = (props: Props) => {
  const { speed, itemsToShow, children } = props;
  const { animation, visibleItems } = useFaderTimer({ speed, itemsToShow, children, transitionDuration });

  return (
    <CSSTransition in={animation} classNames="fader" timeout={transitionDuration}>
      <TransitionBox>{visibleItems}</TransitionBox>
    </CSSTransition>
  );
};

export const TransitionBox = styled.div`
  &.fader-enter {
    opacity: 0.01;
  }

  &.fader-enter-active {
    opacity: 1;
    transition: opacity 800ms ease-out;
  }

  &.fader-exit {
    opacity: 1;
  }

  &.fader-exit-active {
    opacity: 0.01;
    transition: opacity ${transitionDuration}ms ease-in;
  }
`;
